<template src="./../templates/Results.html" />

<script setup>
/* eslint-disable no-unused-vars, no-cond-assign, no-param-reassign */

import { watch } from 'vue';

import { results, setResults, isLoading } from '../data/results.js';
import { filters, titleFilter, filtersHaveLoaded } from '../data/filters.js';
import { routing } from '../data/routing.js';

function doSetResults() {

    if (filtersHaveLoaded.value) {

        setResults();

        routing.updateURLFromFilters();

    }

}

/*
    every time the filters change,
    grab the results!
*/
watch(filters, doSetResults);
watch(titleFilter, doSetResults);

</script>
